<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <router-link to="/attendance">Kehadiran</router-link>
                    <span class="separator">/</span>
                    <span>Mata Kuliah</span>
                </div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Kehadiran Mata Kuliah</h2>
                <p class="page-subtitle">Rekod kehadiran berdasarkan mata kuliah</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-lg-6">
                    
                    <!-- Subject Cards -->
                    <div class="subject-list">
                        <div class="subject-card" v-for="item in report" :key="item.s_id">
                            <!-- Subject Header -->
                            <div class="subject-header" 
                                 :class="{ 'collapsed': !item.isOpen }"
                                 @click="toggleSubject(item)">
                                <div class="subject-title">
                                    <i class="fas fa-book"></i>
                                    <span>{{ item.s_rumiName }}</span>
                                </div>
                                <div class="subject-status">
                                    <span class="status-badge" :class="item.attendance.percent >= 60 ? 'success' : 'danger'">
                                        {{ item.attendance.percent }}%
                                    </span>
                                    <i class="fas fa-chevron-down toggle-icon"></i>
                                </div>
                            </div>
                            
                            <!-- Subject Body (Collapsible) -->
                            <div class="subject-body" v-show="item.isOpen">
                                <!-- Teacher Info -->
                                <div class="teacher-info">
                                    <i class="fas fa-user-tie"></i>
                                    <span>Pensyarah: <strong>{{ item.t_fnameRumi | upText }} {{ item.t_lnameRumi | upText }}</strong></span>
                                </div>
                                <div class="teacher-info" v-if="is_leader && item.t_telephone">
                                    <i class="fas fa-phone"></i>
                                    <span>Telpon: <strong>{{ item.t_telephone }}</strong></span>
                                </div>
                                
                                <!-- Attendance Stats -->
                                <div class="attendance-stats">
                                    <div class="stat-item success">
                                        <span class="stat-label">Hadir</span>
                                        <span class="stat-value">{{ item.attendance.hadir }}</span>
                                    </div>
                                    <div class="stat-item danger">
                                        <span class="stat-label">Ghaib</span>
                                        <span class="stat-value">{{ item.attendance.ghaib }}</span>
                                    </div>
                                    <div class="stat-item warning">
                                        <span class="stat-label">Uzur</span>
                                        <span class="stat-value">{{ item.attendance.uzur }}</span>
                                    </div>
                                    <div class="stat-item total">
                                        <span class="stat-label">Jumlah</span>
                                        <span class="stat-value">{{ item.attendance.total }}</span>
                                    </div>
                                </div>
                                
                                <!-- Detail Button -->
                                <div class="action-row">
                                    <router-link :to="`/attendanceDetail/${$route.params.sr_id}`">
                                        <button @click="attendanceDetail(item.rs_id)" class="btn-view-detail">
                                            <i class="fas fa-list"></i> Lihat Detail
                                        </button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Empty State -->
                        <div v-if="report.length === 0 && !loading" class="empty-state">
                            <i class="fas fa-inbox"></i>
                            <p>Tiada mata kuliah dijumpai</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/services/BackendService'
    export default {
        mounted(){
            this.retreiveAttendance()
        },
        data(){
            return{
                report: [],
                is_leader: '',
                loading: false
            }
        },
        filters: {
            upText(value) {
                if (!value) return ''
                return value.toString().toUpperCase()
            }
        },
        methods:{
            toggleSubject(item) {
                this.$set(item, 'isOpen', !item.isOpen)
            },
            printReport(){
                window.open(`${process.env.VUE_APP_URL_COOKIE}learning/printReportAttendancePdf/${this.$route.params.sr_id}`)
            },
            attendanceDetail(s_id){
                localStorage.setItem("attendance_detail_s_id", s_id)
            },
            retreiveAttendance(){
                this.loading = true
                this.$Progress.start()
                http.get(`learning/retreiveAttendance/${this.$route.params.sr_id}`)
                    .then(response => {
                        this.report = response.data.report.map(item => ({
                            ...item,
                            isOpen: false
                        }))
                        this.is_leader = response.data.is_leader
                        this.loading = false
                        this.$Progress.finish()
                    })
                    .catch(error => {
                        this.loading = false
                        if(error.response.status == 401 || error.response.status == 419){
                            this.$store.dispatch("authentication/cencelAuthen")
                        }
                        this.$Progress.fail()
                    })
            }
        } 
    }
</script>

<style scoped>
.subject-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.subject-card {
    background: var(--bg-white);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow-sm);
    overflow: hidden;
    transition: var(--transition-normal);
}

.subject-card:hover {
    box-shadow: var(--shadow-md);
}

.subject-header {
    background: var(--primary-gradient);
    color: var(--text-white);
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: var(--transition-fast);
}

.subject-header:hover {
    opacity: 0.95;
}

.subject-title {
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 600;
}

.subject-title i {
    font-size: 1.1rem;
}

.subject-status {
    display: flex;
    align-items: center;
    gap: 12px;
}

.status-badge {
    padding: 4px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 0.85rem;
}

.status-badge.success {
    background: rgba(255, 255, 255, 0.25);
    color: var(--text-white);
}

.status-badge.danger {
    background: rgba(220, 53, 69, 0.9);
    color: var(--text-white);
}

.toggle-icon {
    transition: transform 0.3s ease;
}

.subject-header:not(.collapsed) .toggle-icon {
    transform: rotate(180deg);
}

.subject-body {
    padding: 20px;
    border-top: 1px solid #f0f0f0;
}

.teacher-info {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    color: var(--text-secondary);
    font-size: 0.95rem;
}

.teacher-info i {
    color: var(--primary-color);
    width: 20px;
}

.attendance-stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin: 20px 0;
}

.stat-item {
    text-align: center;
    padding: 12px;
    border-radius: var(--border-radius-sm);
}

.stat-item.success {
    background: rgba(71, 192, 122, 0.1);
    color: var(--primary-color);
}

.stat-item.danger {
    background: rgba(220, 53, 69, 0.1);
    color: #dc3545;
}

.stat-item.warning {
    background: rgba(255, 193, 7, 0.15);
    color: #b8860b;
}

.stat-item.total {
    background: #f8f9fa;
    color: var(--text-primary);
}

.stat-label {
    display: block;
    font-size: 0.8rem;
    font-weight: 500;
    margin-bottom: 4px;
}

.stat-value {
    display: block;
    font-size: 1.3rem;
    font-weight: 700;
}

.action-row {
    text-align: right;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
}

.btn-view-detail {
    background: var(--primary-gradient);
    color: var(--text-white);
    border: none;
    padding: 10px 20px;
    border-radius: var(--border-radius-sm);
    font-weight: 500;
    font-size: 0.9rem;
    cursor: pointer;
    transition: var(--transition-normal);
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.btn-view-detail:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-sm);
}

.empty-state {
    text-align: center;
    padding: 60px 20px;
    color: var(--text-secondary);
    background: var(--bg-white);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow-sm);
}

.empty-state i {
    font-size: 3rem;
    margin-bottom: 16px;
    opacity: 0.4;
}

@media (max-width: 576px) {
    .attendance-stats {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>